import {
  AnalyticsSiteAssets,
  setAdobeAnalytics
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { AnalyticsClick } from '@com-delta-idp/mnx-skymiles-shared';
import {
  AUTHENTICATED_USER,
  CLICK_TYPE,
  DATA_ANALYTICS,
  EVENT_DETAIL
} from '../../models';

export const setAnalyticsClick = (
  data: AnalyticsClick,
  assets: AnalyticsSiteAssets[]
) => {
  const selectedAsset = assets.find((asset) => asset.id === data.id);
  const analyticsData = {
    event_detail: EVENT_DETAIL.TILE_CLICK,
    event: DATA_ANALYTICS.CLICK,
    user: AUTHENTICATED_USER,
    click: {
      name: data.name,
      type: CLICK_TYPE.LINK,
      page_section: CLICK_TYPE.TILE,
      page_subsection: data.title,
      action: data.title + ' ' + DATA_ANALYTICS.CLICK
    },
    site_assets: [selectedAsset]
  };
  setAdobeAnalytics(analyticsData);
};
